<template>
    <header class="divider">
        <slot></slot>
    </header>
</template>
